import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { DataSource, Repository, getConnection } from "typeorm";
import { CommonResponseModel, driverIdReq, roleReq, vendorReq } from "@project-management-system/shared-models";
import { ErrorResponse } from "packages/libs/backend-utils/src/models/global-res-object";
import { VendorDto } from "./vendor.dto";
import { VendorEntity } from "./vendor.entity";
import { VendorReportDto } from "./vendor-report.dto";


@Injectable()
export class VendorService {
    constructor(
        @InjectRepository(VendorEntity)

        private repo: Repository<VendorEntity>,
        private readonly dataSource: DataSource,

    ) { }

    async createVendor(req: VendorDto): Promise<CommonResponseModel> {

        try {

            const Check = await this.repo.find({ where: { vendorName: req.vendorName, phoneNumber: req.phoneNumber } })
            if (Check.length > 0) {
                return new CommonResponseModel(false, 0, 'Vendor Name already exists')
            }
            const entity = new VendorEntity()
            entity.vendorName = req.vendorName;
            entity.vendorCode = req.vendorCode;
            entity.vendorType = req.vendorType;
            entity.contactPerson = req.contactPerson;
            entity.phoneNumber = req.phoneNumber;
            entity.gstNumber = req.gstNumber;
            entity.address = req.address;
            entity.plantId = req.plantId;
            entity.createdUser = req.createdUser;
            entity.isActive = req.isActive;
            entity.versionFlag = req.versionFlag;
            entity.updatedUser = req.updatedUser;
            if (req.id) {

                entity.updatedUser = req.createdUser

            } else {

                entity.createdUser = req.createdUser
            }
            const save = await this.repo.save(entity)
            if (!save) {

                return new CommonResponseModel(false, 0, 'Something went wrong in Employee creation', [])
            } else {

                return new CommonResponseModel(true, 1, 'Created successfully', save)
            }

        } catch (err) {

            throw err
        }
    }


    async getAllVendors(req?: driverIdReq): Promise<CommonResponseModel> {
        // console.log(req ,'rrrrrrrrr')
        try {
            const queryOptions: any = {
                relations: ["plantsInfo"],
                order: { createdAt: "DESC" },
            };
    
            const query = this.repo.createQueryBuilder("vendor").select();
    
            if (req && req.plant) {
                query.andWhere(`plantsInfo.plant_name = '${req.plant}'`);
            }
    
            query
                .leftJoinAndSelect("vendor.plantsInfo", "plantsInfo")
                .orderBy("vendor.createdAt", "DESC");
    
            const data = await query.getMany();
    
            return new CommonResponseModel(true, 1, 'Data retrieved successfully', data);
        } catch (err) {
            return new CommonResponseModel(false, 0, 'Error retrieving data', err.message);
        }
    }
    

    async getActiveAllVendor(): Promise<CommonResponseModel> {
        const data = await this.repo.find({relations:["plantsInfo"],
            where: {
                isActive: true
            }
        })

        if (data.length > 0) {
            return new CommonResponseModel(true, 1, 'data retrived Sucessfully', data)
        }
        return new CommonResponseModel(true, 1, 'data retrived Sucessfully', [])
    }


    async updateVendor(req: VendorDto): Promise<CommonResponseModel> {//to add dto
        // console.log(req, "update details");
        try {
            let Product;
            Product = await this.repo.update(
                { id: req.id },
                { vendorName : req.vendorName,
                    vendorCode : req.vendorCode,
                    vendorType : req.vendorType,
                    contactPerson : req.contactPerson,
                    phoneNumber : req.phoneNumber,
                    gstNumber: req.gstNumber,
                    address : req.address,
                    createdUser : req.createdUser,
                    isActive : req.isActive,
                    versionFlag : req.versionFlag,
                    updatedUser : req.updatedUser, }
            )
            if (Product.affected > 0) {
                return new CommonResponseModel(true, 11, 'updated successfully', Product);
            }
            else {
                return new CommonResponseModel(false, 11, 'uploaded failed', []);
            }
        }
        catch (error) { 
            console.log(error);
        }
    }

    async activateOrDeactivateVendor(req: any): Promise<CommonResponseModel> {// add dto
        try {
            // console.log(req.isActive, 'service-----------')
            const Exists = await this.repo.findOne({ where: { id: req.id } });
            if (Exists) {
                if (!Exists) {
                    throw new ErrorResponse(10113, 'Someone updated the current Vendor information.Refresh and try again');
                } else {

                    const update = await this.repo.update(
                        { id: req.id },
                        { isActive: req.isActive, updatedUser: req.updatedUser });
                    if (Exists.isActive) {
                        if (update.affected) {
                            const Response: CommonResponseModel = new CommonResponseModel(true, 10115, 'Vendor is Deactivated successfully');
                            return Response;
                        } else {
                            throw new CommonResponseModel(false, 10111, 'Vendor is already deactivated');
                        }
                    } else {
                        if (update.affected) {
                            const Response: CommonResponseModel = new CommonResponseModel(true, 10114, 'Vendor is activated successfully');
                            return Response;
                        } else {
                            throw new CommonResponseModel(false, 10112, 'Vendor is already  activated');
                        }
                    }

                }
            } else {
                throw new CommonResponseModel(false, 99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getAllVendorRequests(req: VendorReportDto): Promise<CommonResponseModel> {
        try {
            const data = 
                `SELECT 
                v.vendor_name AS vendorName,
                vr.status AS acceptedRequests,
                vr.distance AS distance,
                vr.cost AS cost,
                e.employee_name AS assignedTo,
                ve.vehicle_name AS assignedVehicle,
                vr.vehicle_required_on AS dateRequested,
                vr.source AS source,
                vr.destination AS destination
            FROM 
                vendor v
            LEFT JOIN 
                vehicle_request vr ON v.id = vr.vendor_id
            LEFT JOIN
                employee e ON vr.employee_id = e.id
            LEFT JOIN
                vehicle ve ON vr.vehicle_id = ve.id
            WHERE 
                vr.vehicle_required_on BETWEEN '${req.fromDate}' AND '${req.toDate}';
            
            `
                ;

            //     ` SELECT 
            //        v.vendor_name AS vendorName,
            //     vr.status AS acceptedRequests,
            //     vr.distance AS distance,
            //     vr.cost AS cost,
            //     vr.vehicle_required_on
            // FROM 
            //     vendor v
            // LEFT JOIN 
            //     vehicle_request vr ON v.id = vr.vendor_id
            // WHERE 
            // vr.STATUS = 'Vehicle assigned' AND
            //     vr.vehicle_required_on BETWEEN '${req.fromDate}' AND '${req.toDate}';`
            //     ;
            const record = await this.dataSource.query(data);

            if (record.length > 0) {
                return new CommonResponseModel(true, 1, 'Data retrieved Successfully', record);
            }
            return new CommonResponseModel(false, 0, 'No Data Retrieved ', []);
        } catch (err) {
            throw err;
        }
    }
    async getAllvendorCoderequest(req?: vendorReq): Promise<CommonResponseModel> {
        // console.log(req,'yyyyyyyyyyyyyyyyyyyyyyyyyyyyy');
        try{
        let query = `
           SELECT v.vehicle_type as vehicleType,v.vendor_code AS externalRefNo
          FROM vendor v `;
      
        if (req?.externalRefNo) {
          query += `WHERE v.vendor_code = '${req.externalRefNo}' `;
        }
      
        const result = await this.repo.query(query);
      
        if (result) {
          return new CommonResponseModel(true, 1, "Data Retrieved", result);
        } else {
          return new CommonResponseModel(false, 0, "Data Retrieved");
        }
    }catch(err){ throw err}
      }

}